<template>
  <div>
    <div class="closeButton">
      <span @click="closeForget" title="关闭" >X</span>
    </div>
    <div>
      <el-steps :active="active" align-center>
        <el-step title="验证手机" ></el-step>
        <el-step title="修改密码" ></el-step>
        <el-step title="修改完成" ></el-step>
      </el-steps>
      <div v-if="active === 0 " class="forget-main">
        <div class="forget-main-item">
          <span>手机号：</span>
          <input v-model="phoneNum" @input="checkPhoneNum" placeholder="请输入内容" />
          <aside class="aside-check" v-show="!isPhoneNum">手机号格式错误</aside>
        </div>
        <div class="forget-main-item">
          <span>验证码：</span>
          <input v-model="verifyCode" placeholder="请输入内容" />
          <img @click="_changeVerifyCode" :src="verifySrc" alt>
        </div>
        <div class="forget-main-item">
          <span>短信验证码：</span>
          <input v-model="noteCode" placeholder="请输入内容" />
          <el-button class="getCode" @click="getValidateCode()" :disabled="getCode.isDisable" >{{getCode.text}}</el-button>
        </div>
        <el-button class="confirmButton" :disabled="!(isPhoneNum && phoneNum && verifyCode && noteCode)" @click="submitNoteCode">确定</el-button>
      </div>
      <div v-if="active === 1 " class="forget-main" >
        <div class="forget-main-item-1">
          <span>新密码：</span>
          <input v-model="password" type="password"  placeholder="请输入内容" />
        </div>
         <aside class="aside-check-1" v-show="!isPassword">密码必须包含数字、大小写字母,长度在6到20个字符之间</aside>
        <div class="forget-main-item-1">
          <span>确认密码：</span>
          <input v-model="confirmPassword" type="password"   placeholder="请输入内容" />
        </div>
         <aside class="aside-check-1" v-show="!isConfirmPassword">确认密码与新密码不同</aside>
        <el-button class="confirmButton" :disabled="!(isConfirmPassword && isPassword && password && confirmPassword) " @click="submitChangePassword">提交</el-button>
      </div>
      <div class="forget-main-2" v-if="active === 2 || active === 3">
        <img src="../../../../static/image/forget.png" alt="">
        <el-button class="confirmButton" @click="confirmBack" >确定</el-button>
      </div>
    </div>
  </div>
</template>
<style scoped lang="stylus" rel="stylesheet/stylus">
  .closeButton{
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
    font-size: 15px;
    color: #333;
  }
  @keyframes move{
    from {transform:rotate(0deg);}
    to {transform:rotate(360deg);}
  }
  .closeButton:hover{
    font-size: 17px;
    animation:move 1s infinite;
  }
  .getCode{
    background: #00abad;
    color: #fff;
  }
  .getCode:hover{
    background #039b9c
  }
  .getCode:disabled {
    background #9E9E9E
  }
  .aside-check{
    font-size: 12px;
    color: #e21506;
  }
  .aside-check-1{
    font-size: 12px;
    color: #e21506;
    position :absolute;
    left 110px;
    margin-top -10px;
    width: 220px;
  }
  .confirmButton{
    width 120px;
    height 36px;
    margin 0 auto;
    background: #00abad;
    color: #fff;
    position: absolute;
    bottom: 22px;
    left: 50%;
    margin-left: -60px;
  }
  .confirmButton:hover{
    background #039b9c
  }
  .confirmButton:disabled {
    background #9E9E9E
  }
  .forget-main{
    width: 94%;
    margin: 0 auto;
    padding: 15px 0 30px 0;
    font-size: 16px;
    .forget-main-item{
      padding: 12px 0;
      display :flex;
      align-items center;
      input{
        height: 30px;
        width: 150px;
        margin-right 10px;
        padding-left: 5px;
      }
    }
    .forget-main-item-1{
      padding: 25px 0;
      display :flex;
      align-items center;
      input{
        height: 30px;
        width: 220px;
        padding-left: 5px;
      }
    }
    span{
      display:inline-block;
      width :100px;
      text-align :right;
      color: #333;
      font-weight: bold;
    }

  }
  .forget-main-2{
    text-align: center;
    font-size: 30px;
    color: #333;
    img {
      width 200px;
    }
    p {
      font-weight bold;
      line-height: 2;
    }
  }
</style>
<script>
import http from "@/api/http";
export default {
  data() {
    return {
      phoneNum:"",//手机号
      verifyCode:"",//验证码
      noteCode:"",//短信验证码
      isPhoneNum:true,//手机号是否符合规则
      password:"",
      isPassword:true,//是否符合规定密码
      confirmPassword:"",
      isConfirmPassword:true,//是否符合确认密码
      getCode: {
          status: "init",
          text: "发送验证码",
          delay: 0,
          isDisable: false,
      },
      active:0,
      verifySrc: `${window.BASE_URL}code.json?${Math.random()}`,
      tempKey:"",//重置密码需要的key
    }
  },
  watch: {
        "getCode.status": function(val, oldVal) {
            const obj = this.getCode;
            switch (val) {
              case "init":
                  obj.text = "发送验证码";
                  obj.delay = 0;
                  obj.isDisable = false;
                  break;
              case "waiting":
                  obj.isDisable = true;
                  obj.delay = 60;
                  obj.text = `${obj.delay}秒后重发`;
                  let ender = setInterval(() => {
                      if (obj.delay <= 0) {
                          clearInterval(ender);
                          obj.delay = 0;
                          obj.status = "init";
                      } else {
                          obj.delay--;
                          obj.text = `${obj.delay}秒后重发`;
                      }
                  }, 1000);
                  break;
              case "disable":
                  obj.isDisable = true;
                  obj.text = "无法获取";
                  obj.delay = Infinity;
                  break;
              default:
                  //回滚
                  obj.status = oldVal;
                  //控制台输出错误信息
                  console.error("非法设置获取验证码按钮状态");
                  break;
            }
        },
        "password": function(val, oldVal) {
          const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
          if(reg.test(val)){
            this.isPassword = true;
          }else{
             this.isPassword = false;
          }
        },
        "confirmPassword": function(val, oldVal) {
          if(val !== this.password){
            this.isConfirmPassword = false;
          }else{
            this.isConfirmPassword = true;
          }
        },
  },
  props:{
    num:{
      type: Number,
      required:true,
    },
  },
  methods:{
    confirmBack(){
      this.active =3 ;
      setTimeout(()=>{
        this.$emit("closeForget");
      },500)
    },
    submitChangePassword(){
      const parmars={
        tempKey:this.tempKey,
        newPass:hex_md5(this.password),
        renewPass:hex_md5(this.confirmPassword),
      }
      http.post("/findPwd/reset.htm", parmars).then(res => {
        if (res.data.code === "S000") {
          this.active =2 ;
        }else{
          this.$message.error(res.data.msg)
        }
      }).catch(e=>{

      })
    },
    submitNoteCode(){
      if(!this.isPhoneNum){
        return;
      }
      if(!this.phoneNum){
        this.$message.error("请输入手机号");
        return;
      }
      if(!this.verifyCode){
        this.$message.error("请输入图形验证码");
        return;
      }
      if(!this.noteCode){
        this.$message.error("请输入短信验证码");
        return;
      }
      const parmars={
        userType: 2,
        mobile: this.phoneNum,
        checkCode: this.verifyCode,
        code: this.noteCode
      }
      http.post("/findPwd/vali.htm", parmars).then(res => {
        if (res.data.code === "SUCCESS") {
          this.active =1 ;
          this.tempKey = res.data.model;
        }else{
          this.$message.error(res.data.msg)
        }
      }).catch(e=>{

      })
    },
    getValidateCode(){
      if(!this.isPhoneNum){
        return;
      }
      if(!this.phoneNum){
        this.$message.error("请输入手机号");
        return;
      }
      if(!this.verifyCode){
        this.$message.error("请输入图形验证码");
        return;
      }
      const params={
        mobile:this.phoneNum,
        checkCode:this.verifyCode,
        userType:2
      }

      http.get('/findPwdSendCode.htm', {"params":params}).then(res => {
          if (res.data.code === "SUCCESS") {
            this.getCode.status = 'waiting';
            this.$message.success("短信发送成功");
          } else {
            //失败重新获取验证码
            this._changeVerifyCode();
            this.$message.error(res.data.msg);
          }
        }).catch(e=>{
        //  this.$message.error(`网络错误，${e}`);
        });
    },
    closeForget(){
      this.$emit("closeForget");
    },
    _changeVerifyCode() {
      if (this.num == 2) {
        this.verifySrc = `${window.BASE_URL}code.json?${Math.random()}`;
      } else if (this.num == 0) {
        window.open(`${window.pacs_URL}code.json?${Math.random()}`);
      }
    },
    checkPhoneNum(){
      const reg = /^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8]|8[0-9]|9[1,8,9])\d{8}$/;
      if(reg.test(this.phoneNum)){
        this.isPhoneNum = true;
      }else{
        this.isPhoneNum = false;
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// forget.vue?38b4c5d4